import Openable from 'utils/lib/openable';

class Toast extends Openable {
  constructor(element) {
    super(element);

    this.classes = {
      active: 'toast--active',
    };
  }
}

export default (element: string | HTMLElement): Toast => new Toast(element);
